import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const Logout = () => {
  const navigate = useNavigate()

  useEffect(() => {
    // Eliminar el token y el usuario del localStorage
    localStorage.removeItem('token')
    localStorage.removeItem('refresh_token')
    localStorage.removeItem('ultimaActividad')
    localStorage.removeItem('user')
    localStorage.removeItem('empresa')
    localStorage.removeItem('permisos')
    localStorage.removeItem('razon_social')
    
    // Redirigir al login
    navigate('/')
  }, [navigate])

  return null // No renderiza nada en la UI
}

export default Logout
